module.exports = __webpack_public_path__ + "img/check.41251f91.svg";